import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "ml-1 font-weight-bold text-h6" }
const _hoisted_2 = { class: "hidden-sm-and-down text-white" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_app_bar_nav_icon = _resolveComponent("v-app-bar-nav-icon")!
  const _component_NavbarPageComponent = _resolveComponent("NavbarPageComponent")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!

  return (_openBlock(), _createBlock(_component_v_app_bar, {
    app: "",
    flat: "",
    absolute: "",
    elevation: "10",
    class: "transparent-navbar text-white"
  }, {
    prepend: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_v_icon, {
          large: "",
          class: "mr-1"
        }, {
          default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
            _createTextVNode("mdi-camera", -1)
          ]))]),
          _: 1
        }),
        _cache[8] || (_cache[8] = _createTextVNode(" Majed Photograph ", -1))
      ])
    ]),
    append: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_v_btn, {
          text: "",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.scrollToSection('PROJECTS')))
        }, {
          default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
            _createTextVNode("Projekte", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_component_v_btn, {
          text: "",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.scrollToSection('METHODOLOGY')))
        }, {
          default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
            _createTextVNode("Methodik", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_component_v_btn, {
          text: "",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.scrollToSection('AQ')))
        }, {
          default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
            _createTextVNode("Q&A", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_component_v_btn, {
          text: "",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.scrollToSection('ABOUT_ME')))
        }, {
          default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
            _createTextVNode("Über mich", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_component_v_btn, {
          text: "",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.scrollToSection('CONTACT')))
        }, {
          default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
            _createTextVNode("Kontakt", -1)
          ]))]),
          _: 1
        })
      ]),
      _createVNode(_component_v_app_bar_nav_icon, {
        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.drawer = true)),
        class: "hidden-md-and-up text-h6"
      }),
      _createVNode(_component_NavbarPageComponent, {
        isActive: _ctx.drawer,
        "onUpdate:isActive": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.drawer) = $event))
      }, null, 8, ["isActive"])
    ]),
    _: 1
  }))
}